import styled from 'styled-components'
import { media } from '@popety-io/ui'

export const PageWrapper = styled.div`
  padding: ${({ theme }) => theme.spacing.large} 0;

  ${media.mobileOnly} {
    padding: ${({ theme }) => theme.spacing.medium} 0;
  }
`

export const HeroSection = styled.div`
  text-align: center;
  padding: ${({ theme }) => theme.spacing.huge} 0;

  ${media.mobileOnly} {
    padding: ${({ theme }) => theme.spacing.large} 0;
  }
`

export const FeatureCard = styled.div`
  padding: ${({ theme }) => theme.spacing.huge};
  border: 1px solid ${({ theme }) => theme.colors.border.default};
  border-radius: ${({ theme }) => theme.borderRadius.large};
  text-align: center;
  margin: ${({ theme }) => theme.spacing.large} 0;

  ${media.mobileOnly} {
    padding: ${({ theme }) => theme.spacing.medium};
    margin: ${({ theme }) => theme.spacing.medium} 0;
  }
`

export const InfoCard = styled.div`
  background: ${({ theme }) => theme.colors.background.secondary};
  padding: ${({ theme }) => theme.spacing.large};
  border-radius: ${({ theme }) => theme.borderRadius.medium};
  text-align: center;
  margin: ${({ theme }) => theme.spacing.large} 0;

  ${media.mobileOnly} {
    padding: ${({ theme }) => theme.spacing.medium};
    margin: ${({ theme }) => theme.spacing.medium} 0;
  }
`
